import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApprovalService {

    private approvalStageShowIcon = new BehaviorSubject(true);
    currentApprovalStageShowIcon = this.approvalStageShowIcon.asObservable();

    private approvalStageMenu = new BehaviorSubject({});
    currentApprovalStageMenu = this.approvalStageMenu.asObservable();

    private proccessingMethod = new BehaviorSubject({});
    currentProccessingMethod = this.proccessingMethod.asObservable();

    constructor() {}

    updateShowIcon(isShow: boolean) {
        this.approvalStageShowIcon.next(isShow)
    }

    updateMenu(menu: object) {
        this.approvalStageMenu.next(menu);
    }

    updateInProgress(status: boolean) {
        this.proccessingMethod.next(status);
    }
}